import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeleteFormService {

  constructor(private http: HttpClient) { }

  loadForms(baseUrl: string, submissionId: string, ssoId: string): Observable<any> {
    const urlEncoded = new URLSearchParams();
    urlEncoded.set('submission_id', submissionId);
    urlEncoded.set('sso_id', ssoId);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      `${baseUrl}/loadJsonObject?action_code=tfmy4n`,
      urlEncoded.toString(),
      { headers, withCredentials: true }
    );
  }

  loadFormElements(baseUrl: string, formId: string, ssoId: string): Observable<any> {
    const urlEncoded = new URLSearchParams();
    urlEncoded.set('form_id', formId);
    urlEncoded.set('sso_id', ssoId);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      `${baseUrl}/loadJsonObject?action_code=sd6tf4`,
      urlEncoded.toString(),
      { headers, withCredentials: true }
    );
  }

  deleteForm(efileApiUrl: string, submissionId: string, formId: string): Observable<any> {
    return this.http.get<any>(
      `${efileApiUrl}/deleteForm?submissionId=${submissionId}&formId=${formId}`,
      { withCredentials: true }
    );
  }
}
